module.exports = __webpack_public_path__ + "static/media/fishing_marker_light_blue.00709639.svg";